export var queryJSON = function queryJSON() {
  try {
    var _window, _window$location;

    if (typeof window === "undefined") {
      return {};
    }

    var q = (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.search.substring(1);
    return JSON.parse('{"' + q.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
      return key === "" ? value : decodeURIComponent(value);
    });
  } catch (e) {
    return {};
  }
};